export const getFourEyesId = () => window.adp_foureyes_id;
